import { getCurrentDate } from "../util";

const loginData = (state = null, action) => {
  if (action.type === "SET_LOGIN_DATA") {
    return action.data;
  }
  return state;
};

const authStatus = (state = false, action) => {
  if (action.type === "SET_AUTH_STATUS") {
    state = !state;
    return state;
  }
  return state;
};

const activityData = (state = null, action) => {
  if (action.type === "SET_ACTIVITY_DATA") {
    return action.data;
  }
  return state;
};

const availabilityData = (state = null, action) => {
  if (action.type === "SET_AVAILABILITY_DATA") {
    return action.data;
  }
  return state;
};

const escalationMatrixData = (state = null, action) => {
  if (action.type === "SET_ESCALATION_MATRIX_DATA") {
    return action.data;
  }
  return state;
};

const switchClubData = (state = null, action) => {
  if (action.type === "SET_SWITCH_CLUB_DATA") {
    return action.data;
  }
  return state;
};

const slotUnavailabilityData = (state = null, action) => {
  if (action.type === "SET_SLOT_UNAVAILABILITY_DATA") {
    return action.data;
  }
  return state;
};

const cart = (state = null, action) => {
  if (action.type === "SET_CART_DATA") {
    return action.data;
  }
  return state;
};

const countryCodes = (state = null, action) => {
  if (action.type === "SET_COUNTRY_CODES_DATA") {
    return action.data;
  }
  return state;
};

const customerData = (state = null, action) => {
  if (action.type === "SET_CUSTOMER_DATA") {
    return action.data;
  }
  return state;
};

const bookingData = (state = null, action) => {
  if (action.type === "SET_BOOKING_DATA") {
    return action.data;
  }
  return state;
};

const priceClassData = (state = null, action) => {
  if (action.type === "SET_PRICE_CLASS_DATA") {
    return action.data;
  }
  return state;
};

const pricingDetails = (state = null, action) => {
  if (action.type === "SET_PRICING_DATA") {
    return action.data;
  }
  return state;
};

const changePasswordData = (state = null, action) => {
  if (action.type === "SET_CHANGE_PASSWORD_DATA") {
    return action.data;
  }
  return state;
};

const deskUserData = (state = null, action) => {
  if (action.type === "SET_DESK_USER_DATA") {
    return action.data;
  }
  return state;
};

const payNowData = (state = null, action) => {
  if (action.type === "SET_PAY_NOW_DATA") {
    return action.data;
  }
  return state;
};

const bookingSearchData = (state = null, action) => {
  if (action.type === "SET_BOOKING_SEARCH_DATA") {
    return action.data;
  }
  return state;
};

const bookingTransactionsData = (state = null, action) => {
  if (action.type === "SET_BOOKING_TRANSACTIONS_DATA") {
    return action.data;
  }
  return state;
};

const bookingReportData = (state = null, action) => {
  if (action.type === "BOOKING_REPORT_DATA") {
    return action.data;
  }
  return state;
};

const rescheduleVerifyData = (state = null, action) => {
  if (action.type === "SET_RESCHEDULE_VERIFY_DATA") {
    return action.data;
  }
  return state;
};

const reschedulePriceData = (state = null, action) => {
  if (action.type === "SET_RESCHEDULE_PRICE_DATA") {
    return action.data;
  }
  return state;
};

const transactionCodesData = (state = null, action) => {
  if (action.type === "SET_TRANSACTION_CODES_DATA") {
    return action.data;
  }
  return state;
};

const rescheduleBookingData = (state = null, action) => {
  if (action.type === "SET_RESCHEDULE_BOOKING_DATA") {
    return action.data;
  }
  return state;
};

const bookingDetails = (state = null, action) => {
  if (action.type === "SET_BOOKING_DETAILS_DATA") {
    return action.data;
  }
  return state;
};

const courtListData = (state = null, action) => {
  if (action.type === "SET_COURT_LIST_DATA") {
    return action.data;
  }
  return state;
};

const verifySlotsAvailabilityData = (state = null, action) => {
  if (action.type === "SET_VERIFY_SLOTS_AVAILABILITY_DATA") {
    return action.data;
  }
  return state;
};

const patternBookingSlotsData = (state = null, action) => {
  if (action.type === "SET_PATTERN_BOOKING_SLOTS_DATA") {
    return action.data;
  }
  return state;
};

const editPriceData = (state = null, action) => {
  if (action.type === "SET_EDIT_PRICE_DATA") {
    return action.data;
  }
  return state;
};
const oneSignalId = (state = null, action) => {
  if (action.type === "SET_EDIT_PRICE_DATA") {
    return action.data;
  }
  return state;
};

const enableReschedule = (state = null, action) => {
  if (action.type === "SET_ENABLE_RESCHEDULE") {
    return action.data;
  }
  return state;
};

const markNoShow = (state = null, action) => {
  if (action.type === "SET_NOSHOW") {
    return action.data;
  }
  return state;
};

const notificationData = (state = null, action) => {
  if (action.type === "SET_NOTIFICATION_DATA") {
    return action.data;
  }
  return state;
};

const dashboardData = (state = null, action) => {
  if (action.type === "SET_DASHBOARD_DATA") {
    return action.data;
  }
  return state;
};

const date = (state = getCurrentDate(), action) => {
  if (action.type === "SET_AVAILABILITY_DATE") {
    return action.data;
  }
  return state;
};

const reducers = {
  loginData,
  authStatus,
  activityData,
  availabilityData,
  escalationMatrixData,
  switchClubData,
  slotUnavailabilityData,
  cart,
  countryCodes,
  customerData,
  bookingData,
  changePasswordData,
  deskUserData,
  priceClassData,
  pricingDetails,
  bookingSearchData,
  bookingTransactionsData,
  payNowData,
  bookingReportData,
  rescheduleVerifyData,
  reschedulePriceData,
  rescheduleBookingData,
  transactionCodesData,
  bookingDetails,
  courtListData,
  verifySlotsAvailabilityData,
  patternBookingSlotsData,
  editPriceData,
  oneSignalId,
  enableReschedule,
  markNoShow,
  notificationData,
  dashboardData,
  date,
};

export default reducers;
